export type HeightParams = {
  sourceRef: HTMLDivElement;
  targetRef: HTMLDivElement;
};

export const calculateHeight = ({ sourceRef, targetRef }: HeightParams) => {
  const sourceHeightWithGaps =
    sourceRef.offsetTop + sourceRef.offsetHeight - targetRef.offsetHeight;

  const calculatedHeight = window.innerHeight - sourceHeightWithGaps;

  return calculatedHeight;
};
